import { Topic } from "shared/types";

export const useTopicImage = (topic: Topic) => {
  return {
    smallImage: `https://cdn.dears.media/thumbnail/small/small_${topic.filename}`,
    largeImage: `https://cdn.dears.media/thumbnail/large/large_${topic.filename}`,
  };
};
